import env from "../../utils/env";

const BotFlowService = function (HttpService) {
    "ngInject"

    const getBotFlowsPromise = () => {
        return HttpService.getPromise("bigfoot/bots/flows");
    }


    return { getBotFlowsPromise };
};

export default BotFlowService;


/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/services/bot-flow.service.js
 **/